module.exports = __webpack_public_path__ + "img/About_b3.44fe29a1.png";